import React from "react";
import './RightBold.css' 


export default props => (
  <div className="right-bold">
    {props.block.text}
  </div>
);
